function convertFullDateIndonesia(date) {
  // Pastikan format date adalah YYYY-MM-DD
  const parsedDate = String(date).substring(0, 10);
  const year = parsedDate.substring(0, 4);
  const month = parseInt(parsedDate.substring(5, 7)) - 1;
  const day = parsedDate.substring(8, 10);

  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return `${day} ${months[month]} ${year}`;
}

export { convertFullDateIndonesia };
